import { useEffect, useState } from 'react';
import './App.css';
import Home from './pages/home';

const greetings = ['Hello', 'नमस्ते', 'Hola', 'こんにちは', 'Hallo'];

function App() {
  const [loaderIndex, setLoaderIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setLoaderIndex((prevIndex) => (prevIndex + 1) % greetings.length);
    }, 500);

    const timeout = setTimeout(() => {
      clearInterval(interval);
      setIsLoading(false);
    }, 2600);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);

  return (
    <div className="App">
      {isLoading ? (
        <div className="loader-screen">
          <div key={greetings[loaderIndex]} className="loader-text">
            {greetings[loaderIndex]}
          </div>
        </div>
      ) : (
        <Home />
      )}
    </div>
  );
}

export default App;
